import PropTypes from 'prop-types';
import './Switch.css';

export default function Switch({
    label,
    checked = false,
    onChange,
    disabled = false,
    size = 'md',
    className = ''
}) {
    return (
        <label className={`switch-wrapper ${disabled ? 'disabled' : ''} ${className}`}>
            <div className={`switch switch-${size} ${checked ? 'checked' : ''}`}>
                <input
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange?.(e.target.checked)}
                    disabled={disabled}
                />
                <span className="switch-slider" />
            </div>
            {label && <span className="switch-label">{label}</span>}
        </label>
    );
}

Switch.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    className: PropTypes.string
};
